import { render } from "./Principal-accessRequest.vue?vue&type=template&id=4c9e8719"
import script from "./Principal-accessRequest.vue?vue&type=script&lang=js"
export * from "./Principal-accessRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__